// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import GlaromatUserResourceViewModel from '../../../../viewModel/resource/GlaromatUserResourceViewModel';
import GlaromatUserResourceDTO from '../../dto/resource/GlaromatUserResourceDTO';

export default abstract class GlaromatUserResourceModel extends BaseModel<GlaromatUserResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  */
  get siHaAgbAccepted() { return this.dto.siHaAgbAccepted; }
  set siHaAgbAccepted(value) { this.dto.siHaAgbAccepted = value; }
  /**
  */
  get companyLogoDocumentExternalId() { return this.dto.companyLogoDocumentExternalId; }
  set companyLogoDocumentExternalId(value) { this.dto.companyLogoDocumentExternalId = value; }
  /**
  */
  get companyName() { return this.dto.companyName; }
  set companyName(value) { this.dto.companyName = value; }
  /**
  */
  get companyAddress() { return this.dto.companyAddress; }
  set companyAddress(value) { this.dto.companyAddress = value; }
  /**
  */
  get firstName() { return this.dto.firstName; }
  set firstName(value) { this.dto.firstName = value; }
  /**
  */
  get lastName() { return this.dto.lastName; }
  set lastName(value) { this.dto.lastName = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    value = qs.siHaAgbAccepted === 'true' ? true : qs.sihaagbaccepted;
    value = qs.siHaAgbAccepted === 'false' ? false : undefined;
    this.dto.siHaAgbAccepted = value;
    this.dto.companyLogoDocumentExternalId = qs.companylogodocumentexternalid;
    this.dto.companyName = qs.companyname;
    this.dto.companyAddress = qs.companyaddress;
    this.dto.firstName = qs.firstname;
    this.dto.lastName = qs.lastname;
  }
}
